var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaceDisappointed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70 140c38.664 0 70-31.336 70-70S108.664 0 70 0 0 31.336 0 70s31.336 70 70 70zm16.434-27.7c-3.2-3.554-8.641-7.3-16.434-7.3-7.793 0-13.234 3.746-16.434 7.3-1.613 1.805-4.375 1.942-6.18.329-1.804-1.613-1.94-4.375-.327-6.18C51.46 101.555 59.145 96.25 70 96.25c10.855 0 18.54 5.305 22.941 10.2 1.614 1.804 1.477 4.566-.328 6.179-1.804 1.613-4.566 1.476-6.18-.328zM57.777 73.09l-2.023 2.023A43.739 43.739 0 0 1 32.02 87.336l-.684.11a4.35 4.35 0 0 1-5.031-3.61c-.383-2.406 1.203-4.648 3.61-5.031l.683-.11a35.198 35.198 0 0 0 19.004-9.761l2.023-2.024c1.695-1.695 4.484-1.695 6.18 0 1.695 1.695 1.695 4.485 0 6.18h-.028zm24.446 0c-1.696-1.695-1.696-4.485 0-6.18 1.695-1.695 4.484-1.695 6.18 0l2.023 2.024a34.834 34.834 0 0 0 19.004 9.761l.683.11c2.38.41 3.992 2.652 3.61 5.03-.383 2.38-2.653 3.993-5.032 3.61l-.683-.11c-8.996-1.503-17.309-5.769-23.735-12.222L82.25 73.09h-.027z",
    fill: "#E5E3E4",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceDisappointed);
export default __webpack_public_path__ + "static/media/face-disappointed.0d10012f008679e03f896bc4a04f1efd.svg";
export { ForwardRef as ReactComponent };